var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRostelecom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 290.1H21.1C12.5 290.1 7.5 282.5 7.5 275.8C7.5 271.8 9.1 268.3 11.7 265.7L63.3 214.1L139.5 290.1Z",
    fill: "#FF4F12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 290.1C12.2 290.1 1.00001 283 1.00001 268.7V109.6C1.00001 88.1 -0.0999908 73 15.3 57.6L72.9 0L175.1 102.3L11.7 265.6C9.1 268.2 7.50001 271.8 7.50001 275.7C7.60001 282.4 12.6 290.1 21.1 290.1Z",
    fill: "#7800FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRostelecom);
export default __webpack_public_path__ + "static/media/rostelecom.28fa8968c191292320b96d314b4ff55e.svg";
export { ForwardRef as ReactComponent };